import React, { useState, useEffect, useRef } from 'react';
import "../MainPage/MainPage.css"
import MenuBar from '../../components/MenuBar/MenuBar';
import Map from '../../components/Map/Map';
import Item from '../../components/Item/Item';
import Header from '../../components/Header/Header';
import System from '../../components/System/System';
import LogSystem from '../../components/LogSystem/Logsystem';



const MainPage = () => {
  const [activeTab, setActiveTab] = useState('dataset'); // dataset/admin
  const [adminSubTab, setAdminSubTab] = useState('system'); // 'system' or 'log'

  return (
    <>
      <Header />
      <div className='container'>
        <MenuBar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setAdminSubTab={setAdminSubTab} // AdminPanel 선택 반영
        />
        <div className='infobox'>
          {activeTab === 'dataset' && (
            <>
              <Map />
              <Item />
            </>
          )}
          {activeTab === 'admin' && (
            <>
              {adminSubTab === 'system' && <System />}
              {adminSubTab === 'log' && <LogSystem />}
            </>
          )}
        </div>
      </div>
    </>
  );
};


export default MainPage;


